export const environment = {
  apiBaseUrl: 'https://flw.devtest.gf.aws.scania.com/api/',
  buildTimestamp: "26-05-18@11:19",
  production: true,
  msalConfig: {
    auth: {
      clientId: '10869814-e115-4c52-86cc-848a7d8df54b',
      authority: 'https://login.microsoftonline.com/3bc062e4-ac9d-4c17-b4dd-3aad637ff1ac'
    },
  },
  webApi: {
    uri: 'https://flw.devtest.gf.aws.scania.com/api/',
    scopes: ['api://flw-dev/flw.read'],
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
};
